
import {
  Image,
  Skeleton,
  Rate,
  Avatar,
  Empty,
  Card,
  Tag,
  Tabs,
} from "antd";

import axios from "axios";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useParams } from "react-router";
import { authenticateToken } from "../../../utils/auth";
import { getImgUrl } from "../../../utils/index";
import { responseNotification } from "../../../utils/notify";


const CategoryProductDetails = ({ selectedProductId }): ReactElement => {
  const { TabPane } = Tabs;

  const [status, setStatus] = useState(false);
  const [update, setUpdate] = useState(false);
  const [visible, setVisible] = useState(false);

  const [singleProductInfo, setSingleProductInfo] = useState({
    loading: false,
    data: null,
  });

  const route = useParams();

  const fetchProductDetails = useCallback((getProductId) => {
    if (getProductId) {
      try {
        setSingleProductInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/product/details?slug=${getProductId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleProductInfo({
                loading: false,
                data: data?.data?.product,
              });
            } else {
              setSingleProductInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleProductInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleProductInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchProductDetails(selectedProductId || (route as any).slug);
  }, [fetchProductDetails, selectedProductId, (route as any).slug]);

  const UpdateStatus = useCallback(() => {
    if (status) {
      axios
        .put(
          `${process.env.REACT_APP_CATALOG_WRITER_API}/product`,
          {
            driverId: singleProductInfo?.data?.driverId,
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((data) => {
          if (data?.status === 200) {
            responseNotification("Status updated successfully!", "success");
            fetchProductDetails(selectedProductId);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [status]);

  useEffect(() => {
    UpdateStatus();
  }, [UpdateStatus]);

  const onEditModalClose = useCallback(() => {
    setUpdate(false);
    fetchProductDetails(selectedProductId);
  }, [fetchProductDetails, selectedProductId]);

  const product = singleProductInfo?.data;
  return (
    <>
      {singleProductInfo?.loading ? (
        <>
          <Skeleton avatar active paragraph={{ rows: 20 }} />
        </>
      ) : (
        <div className="product_details">
          <Tabs defaultActiveKey="basic">
            <TabPane tab="Basic Information" key="basic">
              <div className="info-body">
                <div className="">
                  <Image
                    preview={{ visible: false }}
                    onClick={() => setVisible(true)}
                    src={getImgUrl(product?.productImage)}
                    alt={product?.name}
                    height={250}
                  />
                  <div style={{ display: "none" }}>
                    <Image.PreviewGroup
                      preview={{
                        visible,
                        onVisibleChange: (vis) => setVisible(vis),
                      }}
                    >
                      <Image
                        preview={{ visible: false }}
                        onClick={() => setVisible(true)}
                        src={getImgUrl(product?.productImage)}
                        alt={product?.name}
                        className="rounded"
                      />
                      {product?.images?.length
                        ? product?.images?.map((image, index) => (
                            <Image src={getImgUrl(image)} className="rounded" />
                          ))
                        : undefined}
                      {product?.variations?.length
                        ? product?.variations?.map((variant, index) => (
                            <Image
                              src={variant?.imageUrl}
                              className="rounded"
                            />
                          ))
                        : undefined}
                    </Image.PreviewGroup>
                  </div>
                </div>

                <div className="inner-body">
                  <div className="single">
                    <span className="info-name">Product Name: </span>
                    <span className="info-desc">{product?.name}</span>
                  </div>

                  <div className="single">
                    <span className="info-name">Slug: </span>
                    <span className="info-desc">{product?.slug}</span>
                  </div>

                  {product?.barCode ? (
                    <div className="single">
                      <span className="info-name">Barcode: </span>
                      <span className="info-desc">{product?.barCode}</span>
                    </div>
                  ) : undefined}

                  {product?.sku ? (
                    <div className="single">
                      <span className="info-name">SKU: </span>
                      <span className="info-desc">{product?.sku}</span>
                    </div>
                  ) : undefined}

                  {product?.type ? (
                    <div className="single">
                      <span className="info-name">Type: </span>
                      <span className="info-desc">
                        {product?.type?.split("_").join(" ")}
                      </span>
                    </div>
                  ) : undefined}

                  <div className="single">
                    <span className="info-name">Category Name: </span>
                    <span className="info-desc">
                      {product?.category?.title}
                    </span>
                  </div>
                  {product?.category?.slug ? (
                    <div className="single">
                      <span className="info-name">Category Slug: </span>
                      <span className="info-desc">
                        {product?.category?.slug}
                      </span>
                    </div>
                  ) : undefined}

                  {product?.brand?.name ? (
                    <div className="single">
                      <span className="info-name">Brand Name: </span>
                      <span className="info-desc">{product?.brand?.name}</span>
                    </div>
                  ) : undefined}

                  {product?.campaign?.name ? (
                    <div className="single">
                      <span className="info-name">Campaign: </span>
                      <span className="info-desc">
                        {product?.campaign?.name}
                      </span>
                    </div>
                  ) : undefined}

                  <div className="single">
                    <span className="info-name">Total Visitors: </span>
                    <span className="info-desc">{product?.visitors}</span>
                  </div>

                  <div className="single">
                    <span className="info-name">Rating</span>
                    <span className="info-desc">
                      {" "}
                      {product?.numberOfRating ? (
                        <Rate value={product?.rating || 0} disabled />
                      ) : (
                        <Rate value={0} disabled />
                      )}
                      <small className="ml-1">
                        ({product?.numberOfRating})
                      </small>
                    </span>
                  </div>

                  <div className="single">
                    <span className="info-name">Status: </span>
                    <span className="info-desc">
                      {/* {product?.status?.split("_").join(" ")} */}
                      <span
                        className={`radius-btn ${
                          product?.deleted === false
                            ? "active-btn"
                            : "deleted-btn"
                        }`}
                      >
                        {product?.deleted === false ? "Active" : "Deleted"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tab="Product Details" key="details">
              <div className="info-body">
                <div className="inner-body">
                  <div className="single-inline">
                    <h4 className="info-name border-bottom pb-2">
                      Description :
                    </h4>

                    <div
                      className="description info-desc text-dark"
                      dangerouslySetInnerHTML={{
                        __html: product?.description,
                      }}
                    />
                  </div>

                  <div className="single-inline mt-5">
                    <h4 className="info-name border-bottom pb-2">Keyword :</h4>
                    <span className="info-desc text-capitalize">
                      {product?.keyword}
                    </span>
                  </div>
                </div>
              </div>
            </TabPane>

            <TabPane tab="Variations" key="variations">
              <div className="inner-body row">
                {product?.variations?.length ? (
                  product?.variations?.map((variant, index) => (
                    <div key={index} className="col-md-6">
                      <Card
                        className="mb-3"
                        // title={variant?.variationName}
                        cover={
                          <>
                            {/* {variant?.imageUrl ? ( */}
                            <div className="p-1">
                              <Avatar
                                shape="square"
                                size={150}
                                src={variant?.imageUrl}
                              />
                            </div>
                            {/* // ) : undefined} */}
                          </>
                        }
                      >
                        <div>
                          <div className="single">
                            <span className="info-name">Variation Name</span>
                            <span className="info-desc">
                              {variant?.variationName}
                            </span>
                          </div>
                          {variant?.barCode ? (
                            <div className="single">
                              <span className="info-name">Barcode</span>
                              <span className="info-desc">
                                {variant?.barCode}
                              </span>
                            </div>
                          ) : undefined}
                          <div className="single">
                            <span className="info-name">Variation Id</span>
                            <span className="info-desc">
                              {variant?.variationId}
                            </span>
                          </div>

                          <div className="single">
                            <span className="info-name">MRP</span>
                            <span className="info-desc">
                              {variant?.price?.mrp}{" "}
                              {variant?.price?.currencyCode}
                            </span>
                          </div>
                          <div className="single">
                            <span className="info-name">TP</span>
                            <span className="info-desc">
                              {variant?.price?.tp}{" "}
                              {variant?.price?.currencyCode}
                            </span>
                          </div>

                          {variant?.price?.discountedPrice ? (
                            <div className="single">
                              <span className="info-name">
                                Discounted Price
                              </span>
                              <span className="info-desc">
                                {variant?.price?.discountedPrice}{" "}
                                {variant?.price?.currencyCode}
                              </span>
                            </div>
                          ) : undefined}

                          {variant?.maximumOrderLimit ? (
                            <div className="single">
                              <span className="info-name">
                                Maximum Order Limit
                              </span>
                              <span className="info-desc">
                                {variant?.maximumOrderLimit}
                              </span>
                            </div>
                          ) : undefined}

                          <div className="single">
                            <span className="info-name">Stock</span>
                            <span className="info-desc">
                              <Tag
                                className={`font-weight-bold px-3 ${
                                  variant?.stock < 10
                                    ? `text-danger`
                                    : `text-success`
                                }`}
                              >
                                {variant?.stock}
                              </Tag>
                            </span>
                          </div>

                          <h6 className="mt-4 border-bottom pb-2">
                            <b>Product Discount :</b>
                          </h6>
                          <div className="single">
                            <span className="info-name">
                              Discount in Amount
                            </span>
                            <span className="info-desc">
                              {variant?.productDiscount?.flat || 0}{" "}
                              {variant?.price?.currencyCode}
                            </span>
                          </div>
                          <div className="single">
                            <span className="info-name">
                              Discount in Percentage
                            </span>
                            <span className="info-desc">
                              {variant?.productDiscount?.percentage || 0} {"%"}
                            </span>
                          </div>
                          {
                            // data.item?.products?.length ?
                            variant?.quantitativeProductDiscount
                              ?.freeProduct ? (
                              <div className="">
                                <h6 className="mt-5 border-bottom pb-2">
                                  <b>Quantitative Product Discount:</b>
                                </h6>
                                <div className="single">
                                  <span className="info-name">
                                    Free Product
                                  </span>
                                  <span className="info-desc">
                                    {
                                      variant?.quantitativeProductDiscount
                                        ?.freeProduct
                                    }
                                  </span>
                                </div>
                                <div className="single">
                                  <span className="info-name">
                                    Minimum Quantity
                                  </span>
                                  <span className="info-desc">
                                    {
                                      variant?.quantitativeProductDiscount
                                        ?.minimumQuantity
                                    }
                                  </span>
                                </div>
                                <div className="single">
                                  <span className="info-name">
                                    Product Discount in Amount
                                  </span>
                                  <span className="info-desc">
                                    {
                                      variant?.quantitativeProductDiscount
                                        ?.productDiscount?.flat
                                    }
                                  </span>
                                </div>
                                <div className="single">
                                  <span className="info-name">
                                    Product Discount in Percent
                                  </span>
                                  <span className="info-desc">
                                    {
                                      variant?.quantitativeProductDiscount
                                        ?.productDiscount?.percentage
                                    }
                                  </span>
                                </div>
                              </div>
                            ) : (
                              ""
                            )
                          }
                        </div>
                      </Card>
                    </div>
                  ))
                ) : (
                  <Empty />
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      )}
    </>
  );
};

CategoryProductDetails.propTypes = {
  selectedProductId: PropTypes.string,
};

export default CategoryProductDetails;
